module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-mobile-en.ec924655.png";